import type { LinkProps } from '@common/Link/Link';
import classNames from 'classnames';
import { Icon } from '@common/Icon/Icon';
import styles from './LinkBox.module.scss';

export interface LinkBoxProps extends LinkProps {
  title: string;
  description: string;
  imageUrl?: string;
}

export const LinkBox = ({
  title,
  description,
  imageUrl,
  onClick,
  href,
  external,
  download,
  className,
  primary,
  icon,
  bigIcon = false,
  iconPrimary = true,
  text,
}: LinkBoxProps) => (
  // eslint can't figure out that we correctly set 'noreferrer' on external links
  // since it set dynamically
  // eslint-disable-next-line react/jsx-no-target-blank
  <a
    data-testid="linkBox-a"
    onClick={onClick}
    href={href}
    target={external ? '_blank' : undefined}
    rel={external ? 'noreferrer' : undefined}
    download={download}
    className={classNames(
      'medium',
      'cursor-pointer',
      primary && 'text-igus-primary',
      'flex',
      'flex-row',
      'group',
      className,
      'mt-1',
      'py-2',
      'px-4',
      'border',
      'border-gray-200',
      'hover:border-gray-500',
      styles.noShadowLink
    )}
  >
    {imageUrl && (
      <div className="p-3">
        <div
          className="relative bg-igus-primary w-24 h-24 rounded-full"
          style={{ backgroundImage: `url(${imageUrl})`, backgroundSize: 'contain' }}
        />
      </div>
    )}
    <div className="text-sm py-5 px-2">
      <p className="font-bold">{title}</p>
      <p className="my-1.5 block">{description}</p>
      {icon && (
        <span className="mr-4">
          <Icon id={icon} size={bigIcon ? 6 : 4} primary={!!iconPrimary} />
        </span>
      )}
      {text}
    </div>
  </a>
);
